<ng-content *ngTemplateOutlet="isNewPreview ? searchPaneNew : searchPaneOld"></ng-content>

<ng-template #searchPaneOld>
  <div [ngClass]="{ 'search-module-wrapper': isWrapper}" (clickOutside)="onClickOutSide($event)">
    <ng-content *ngTemplateOutlet="searchPane"></ng-content>
  </div>
</ng-template>

<ng-template #searchPane>
  <div class="search-module search-module--secondary" [ngClass]="{ 'search-module--call-mon-v2': isCompact }"
    data-input="search">
    <!-- <i class="fa-light fa-magnifying-glass search-module__icon"></i> -->
    <input type="text" placeholder="Search" class="search-module__input" (keyup)="onChangeValue($event)"
      (focus)="onInput($event, 'focus')" id="pr-search" #searchInput type="text"
      [placeholder]="showDateCriteria ? 'MM/dd/yyyy' : 'Search'">
    @if(searchInput.value.length > 0){
    <i class="fa-regular fa-xmark search-cancel" (click)="clearSearch()"></i>
    }
    <i class="fa-regular fa-magnifying-glass search-module__icon" (click)="search()"></i>
    <div #filterModuleContainer class="filter-module-container" data-filter="search-filter"
      [ngStyle]="{ display: showSearchBox ? 'block' : 'none' }">
      <div class="filter-module">
        <div class="filter-module__content">
          <span>Fields</span>
          <div class="filters">
            @if(fields !== undefined){
            <ng-container>
              @for(x of fields; track x; let i = $index){
              <div [class.active]="i === fieldActiveIndex" (click)="setField(x.Value, i, x.Type)">
                <p>{{x.Name}}</p>
              </div>
              }
            </ng-container>
            }
          </div>
        </div>
        <div class="filter-module__content">
          <span>Criteria</span>
          <div class="filters">
            @if(showStringCriteria){
            <ng-container>
              @if(searchStringCriteria !== undefined){
              <ng-container>
                @for(x of searchStringCriteria; track x; let i = $index){
                <div [class.active]="i === criteriaActiveIndex" (click)="setCriteria(x.Value, i)">
                  <p>{{x.Name}}</p>
                </div>
                }
              </ng-container>
              }
            </ng-container>
            }
            @if(showIntegerCriteria || showDateCriteria){

            <ng-container>
              @if(searchIntegerCriteria !== undefined){
              <ng-container>
                @for(x of searchIntegerCriteria; track x; let i = $index){
                <div [class.active]="i === criteriaActiveIndex" (click)="setCriteria(x.Value, i)">
                  <p>{{x.Name}}</p>
                </div>
                }
              </ng-container>
              }
            </ng-container>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Icons Group -->
  <!-- add the select attribute to ng-content -->
  <ng-content select="[filter-icons]"></ng-content>
</ng-template>

<ng-template #searchPaneNew>
  <div class="search-module search-module--secondary" data-input="search" (clickOutside)="onClickOutSide($event)">
    <input type="text" placeholder="Search" class="search-module__input" (keyup)="onChangeValue($event)"
      (focus)="onInput($event, 'focus')" id="pr-search" #searchInput type="text"
      [placeholder]="showDateCriteria ? 'MM/dd/yyyy' : placeholder">
    @if(searchInput.value.length > 0){
    <i class="fa-regular fa-xmark search-cancel" (click)="clearSearch()"></i>
    }
    <i class="fa-regular fa-magnifying-glass search-module__icon" (click)="search()"></i>
    @if(showFilter){
    <div class="filter-module-container" data-filter="search-filter"
      [ngStyle]="{ display: showSearchBox ? 'block' : 'none' }">
      <!-- Filter Module -->
      <div class="filter-module">
        <div class="filter-module__content">
          <span>Fields</span>
          <div class="filters">
            @if(fields !== undefined){
            <ng-container>
              @for(x of fields; track x; let i = $index){

              <div [class.active]="i === fieldActiveIndex" (click)="setField(x.Value, i, x.Type)">
                <p>{{x.Name}}</p>
              </div>
              }
            </ng-container>
            }
          </div>
        </div>
        <div class="filter-module__content">
          <span>Criteria</span>
          <div class="filters">
            @if(showStringCriteria){
            <ng-container>
              @if(searchStringCriteria !== undefined){
              <ng-container>
                @for(x of searchStringCriteria; track x; let i = $index){
                <div [class.active]="i === criteriaActiveIndex" (click)="setCriteria(x.Value, i)">
                  <p>{{x.Name}}</p>
                </div>
                }
              </ng-container>
              }

            </ng-container>
            }
            @if(showIntegerCriteria || showDateCriteria){
            <ng-container>
              @if(searchIntegerCriteria !== undefined){
              <ng-container>
                @for(x of searchIntegerCriteria; track x; let i = $index){
                <div [class.active]="i === criteriaActiveIndex" (click)="setCriteria(x.Value, i)">
                  <p>{{x.Name}}</p>
                </div>
                }
              </ng-container>
              }
            </ng-container>
            }
          </div>
        </div>
      </div>
    </div>
    } 
  </div>
</ng-template>